import { formatDate } from '../../utils/formatters';

export default function DateInput({
  id,
  label,
  value,
  onChange,
  placeholder = 'MM/DD/YYYY',
  required = false,
  error = '',
  disabled = false
}) {
  const handleChange = (e) => {
    const formatted = formatDate(e.target.value);
    onChange(formatted);
  };

  return (
    <div className="w-full">
      <label htmlFor={id} className="block text-lg font-semibold text-charcoal mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <input
        type="text"
        id={id}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        maxLength={10}
        className={`w-full px-4 py-3 text-lg border-2 rounded-button focus:outline-none focus:ring-2 focus:ring-renuvia-gold transition-all ${
          error
            ? 'border-red-500 focus:ring-red-500'
            : 'border-gray-300 focus:border-renuvia-gold'
        } disabled:bg-gray-100 disabled:cursor-not-allowed`}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}
